import { Config, noticeError } from '@ratehub/base-ui';


/**
 * Get the array of approval likelihood threshold values.
 *  The MINIMUM_THRESHOLDS array must be defined within this function, otherwise when we change Config
 *  settings as part of our tests, they would not be reflected in the array values.
 *  If it wasn’t for that, this array could be defined external to the function.
 * @param {number} segmentIndex - index into an array of threshold values
 * @returns {Array<{excellent: string, good: string, fair: string}>} - minimum threshold values for excellent, good, and fair
 */
function getApprovalLikelihoodMinimums(segmentIndex) {
    // get the four thresholds for the given experiment segment
    const segmentMinimums = Config.CC_APPROVAL_LIKELIHOOD_MINIMUMS[segmentIndex];

    if (!segmentMinimums) {
        // return CONTROL, but complain first
        noticeError(new RangeError('[getApprovalLikelihoodMinimums] Invalid segment index; falling back to default.'), {
            segmentIndex,
            availableSegments: Config.CC_APPROVAL_LIKELIHOOD_MINIMUMS.length,
        });
        return Config.CC_APPROVAL_LIKELIHOOD_MINIMUMS[0];
    }

    return segmentMinimums;
}

export default getApprovalLikelihoodMinimums;
